import React, { ReactNode } from 'react';
import { useContext, useRef, useEffect, FunctionComponent } from 'react';

// MUI
import Box from '@mui/material/Box';

// Custom components
import MapContext from '@/components/Map/MapContext';
import Sidebar from "./sidebar"
// import Sidebar from './ol5-sidebar';
// import './ol3-sidebar.css';
import SidebarContext, { SidebarContextType } from './SidebarContext/SidebarContext';
import { findControl, getDefinedOptions, getEvents } from '@/lib/olHelpers';

// Types
import { MapContextType } from '@/@types/context/MapContext';

export interface ISidebarRoot {
  id?: string
  initialOpenId?: string
  children: ReactNode
}

const SidebarRoot: FunctionComponent<ISidebarRoot> = (props) => {
  const mapContext = useContext(MapContext) as MapContextType;
  const sidebarContext = useContext(SidebarContext) as SidebarContextType;
  const elementRef = useRef<HTMLDivElement | null>(null);

  const { id, initialOpenId, children } = props;

  useEffect(() => {
    if (elementRef.current) {
      const options = {
        element: elementRef.current,
        target: undefined,
        position: 'left'
      };

      const allOptions = Object.assign(options, props);
      const definedOptions = getDefinedOptions(allOptions);

      const events = {};

      const control = new Sidebar(definedOptions);

      if (id) {
        control.set('id', id);
      }

      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, Sidebar);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
        mapContext.map.addControl(control);
      } else {
        mapContext.initOptions.controls.push(control);
      }

      const olEvents = getEvents(events, props);
      for (let eventName in olEvents) {
        //@ts-ignore TODO:  Argument of type 'string' is not assignable to parameter of type '('error' | 'change' | 'propertychange')[]'
        control.on(eventName, olEvents[eventName]);
      }
    }

    return () => {
      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, Sidebar);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
      }
    };
  }, []);

  // const classNames = ['sidebar'];
  // classNames.push('sidebar-' + (position ? position : 'left'));
  // if (sidebarContext.collapsed) {
  //   classNames.push('collapsed');
  // }
  // const joinedClassNames = classNames.join(' ');

  const isCollapsed = sidebarContext.collapsed;
  const isLeft = sidebarContext.position === "left";
  const isRight = sidebarContext.position === "right";

  const classNames: string[] = [];

  if (isLeft) { classNames.push('sidebar-left');  }
  else if (isRight) { classNames.push('sidebar-right'); }
  if (isCollapsed) { classNames.push('collapsed'); }

  return (
    <Box id='sidebar' ref={elementRef}
      className={classNames.join(" ")} 
      sx={{
        position: "absolute",
        top: { xs: 0, sm: 8 },
        right: isRight ? { xs: 0, sm: 8 } : undefined,
        bottom: { xs: 0, sm: 8 },
        left: isLeft ? { xs: 0, sm: 8 } : undefined,
        width: isCollapsed ? 45 : { xs: "100%", sm: 305, md: 390, lg: 460 },
        overflow: "hidden",
        zIndex: 1000,
        transition: "width 500ms",
        border: "3px solid transparent",
        borderRadius: { xs: 0, sm: "4px"}
      }}>
      {children}
    </Box>
  );
};

export default SidebarRoot;
